// A partial history must not look like a complete period.
export async function loadBalanceSnapshots(client, userId) {
  if (!userId) return { data: [], error: 'Sign in to load balance history.' }
  const rows = []
  try {
    for (let offset = 0; offset < 50000; offset += 500) {
      const {data,error} = await client.from('portfolio_snapshots')
        .select('snapshot_date,total_equity,total_cash,account_snapshots')
        .eq('user_id',userId).order('snapshot_date',{ascending:true}).range(offset,offset+499)
      if (error || !Array.isArray(data)) return {data:[],error:'Balance history could not be loaded completely.'}
      rows.push(...data)
      if (data.length < 500) return {data:rows,error:null}
    }
  } catch { /* Fail closed on transport/auth failures as well as database errors. */ }
  return {data:[],error:'Balance history could not be loaded completely.'}
}
